import { useNavigate } from "react-router-dom";
import { i18n } from "../../lang/i18n";
import { useEffect } from "react";
import { actLoading, actLoadingEnd } from "../../store/Actions";
import { useAppDispatch } from "../../store/hooks";

export default function PayWasOk() {
    const dispatch = useAppDispatch()
    const navigate = useNavigate();
    function goHome() {
        actLoadingEnd(dispatch)
        navigate('/user_orders')
    }
    useEffect(() => {
        actLoading(dispatch)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return <div className="modal fade show" style={{display:'block !important'}}>
        <div className="modal-dialog  modal-dialog-centered">
            <div className="modal-content">
                <div className="modal-header">
                    <h5 className="modal-title">{i18n.PaymentOk.Title}</h5>
                    <button type="button" className="close" onClick={() => goHome()}  >
                        <i className="far fa-times-circle" />
                    </button>
                </div>
                <div className="modal-body">
                    <p>{i18n.PaymentOk.Message}</p>
                </div>
                <div className="box p-3 text-center">
                    <button className="btn btn-warning" style={{ minWidth: 250 }}
                        onClick={() => goHome()}><i className="fa fa-check mr-2" />
                        {i18n._BTNs.Continue}
                    </button>
                </div>
            </div>
        </div>
    </div>
}